import StepOne from "../../../components/StepOne";



const OrderCaters = () => {
 

  return (
    <>
      <StepOne />
    </>
  );
};

export default OrderCaters;
